import { PresetViewConfig } from '@bringg/types';

import { AlertsPresetView } from './alerts-preset-view';
import { TasksPresetView } from './tasks-preset-view';

export enum PresetViewsGroupTypes {
	View = 'view'
}

export type AlertTableColumn = {
	active: boolean;
	id: string;
	position?: number;
	width?: number;
	// TODO: investigate usage of `translateKey` and `translate_key` in react-table to merge them into one property
	translateKey?: string;
	translate_key?: string;
};

export type TasksTableConfig = {
	id: number;
	groupMode: string;
	filters: PresetViewConfig['filters'];
	sortOptions:
		| {
				id: string;
				asc: boolean;
		  }
		| undefined;
	columns: PresetViewConfig['columns'];
};

export type AlertTableFilters = Record<string, unknown> & { additionalFiltersNames: Array<string> };

export type AlertTableConfig = {
	id: number;
	groupBy: Array<string>;
	filters: AlertTableFilters;
	sortBy: Array<{
		id: string;
		desc: boolean;
	}>;
	columns: Array<AlertTableColumn>;
};

export type ClientSideConfig = AlertsPresetView | TasksPresetView;
